import { endPoints } from "../../config/end-points";

export const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        Copyright by {endPoints.title} 2023. All Rights Reserved &nbsp;&nbsp;
        {/* <NavLink to="#">Cookies Policy</NavLink>
        <NavLink to="#">Disclaimers</NavLink> */}
      </div>
    </footer>
  );
};
